{
  "select": {
    "addTagText": "Dodaj etykietę",
    "loadingText": "Wczytywanie",
    "notFoundText": "Nie znaleziono danych",
    "clearAllText": "Wyczyść wszystko",
    "typeToSearchText": "Wpisz, aby wyszukać",
    "placeholder": "Wybierz"
  },
  "filter": {
    "buttons": {
      "showFilters": "Pokaż filtry",
      "hideFilters": "Schowaj filtry",
      "clearFilters": "Wyczyść filtry",
      "defaultFilters": "Domyślne filtry",
      "showResults": "Pokaż wyniki"
    },
    "to": "do",
    "selected": "Wybrano {{count}}..."
  },
  "table": {
    "noResults": "Brak wyników",
    "pagination": {
      "summary": "Wyświetlanie {0}-{1} z {2}"
    }
  },
  "sort": {
    "title": "Sortowanie",
    "desc": "malejąco",
    "asc": "rosnąco"
  },
  "boolean": {
    "true": "Tak",
    "false": "Nie"
  },
  "downloadList": {
    "name": "Eksportuj dane",
    "items": {
      "CSV": "csv",
      "XLSX": "xlsx"
    }
  },
  "messages": {
    "fileSizeError": "Dodanie pliku/plików nie powiodło się - przekroczono maksymalny rozmiar pliku."
  }
}
